import { Button } from "@mui/material";

export default function ArtButton() {
const handleClick = () => {
    window.location.href = "/art-services";
};

return (
    <Button
        component="label"

        sx={{
            mb: 1,
            backgroundColor: "#94C940",
            color: "white",
     borderRadius: { xs: "13px", sm: "8px" },
            px: 2.5,
            py: 0.2,
            fontWeight: "1000",
            fontFamily: "Anek Latin",
            fontSize: "1.45rem",
            textTransform: "uppercase",
            "&:hover": {
                backgroundColor: "#94C940",
            },
        }}
        onClick={handleClick}
    >
        Art Services
    </Button>
);
}
